import { render, staticRenderFns } from "./OriginalAboutInfoReview.vue?vue&type=template&id=5f65f7b6"
import script from "./OriginalAboutInfoReview.vue?vue&type=script&lang=js"
export * from "./OriginalAboutInfoReview.vue?vue&type=script&lang=js"
import style0 from "./OriginalAboutInfoReview.vue?vue&type=style&index=0&id=5f65f7b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports